import React from "react";
import { useForm } from "react-hook-form";
import ButtonWithStyle from "../../HOCs/ButtonWithStyle/ButtonWithStyle";
import TextFieldWithStyle from "../../HOCs/InputWithStyle/InputWithStyle";

export default function PinSetter({ onSubmit, data, isLoading }) {
	const { handleSubmit, register } = useForm();
	const { pin = "0000" } = data;

	function localOnSubmit({ oldPin, newPin }) {
		if (oldPin !== pin) {
			alert("Pin Incorrecto");
			return;
		}
		onSubmit({ pin: newPin });
	}

	return (
		<form onSubmit={handleSubmit(localOnSubmit)}>
			<TextFieldWithStyle
				style={{ maxWidth: "300px" }}
				disabled={isLoading}
				margin="normal"
				required
				id="oldPin"
				label="Old Pin"
				name="oldPin"
				autoFocus
				type="password"
				inputRef={register}
			/>
			<br />
			<TextFieldWithStyle
				style={{ maxWidth: "300px" }}
				disabled={isLoading}
				margin="normal"
				required
				id="newPin"
				label="New Pin"
				name="newPin"
				autoFocus
				type="password"
				inputRef={register}
			/>
			<br />
			<ButtonWithStyle variant="contained" type="submit" disabled={isLoading}>
				Guardar
			</ButtonWithStyle>
		</form>
	);
}
